import React from "react";
import RightHandSide from "../../Common/Services/RightHandSide";
import AboutInnBanContent from "../../Common/InnerBanner/AboutInnBanContent";
import { AboutInnerBanner } from "../../Common/InnerBanner/AboutInnerBanner";
import HeadContent from "../BlogContent/HeadContent";
import HeadDesign from "../BlogContent/HeadDesign";
import Info from "../BlogContent/Info";
import List from "../BlogContent/List";
import InfoContent from "../BlogContent/InfoContent";
import ListContent from "../BlogContent/ListContent";
import RecentBlogsList from "../BlogContent/RecentBlogsList";
import { Helmet } from "react-helmet";

const Blog49 = () => {
  const { image, heading, pageName } = AboutInnBanContent.BlogDetails;
  const { bg, para, date, blogHeading } = HeadContent.blog_49;

  const { title, p } = InfoContent.Blog_49.one;
  const { title2, p2 , p2a } = InfoContent.Blog_49.two;
  const { title3, p3, p3a } = InfoContent.Blog_49.three;
  const { title4, p4 } = InfoContent.Blog_49.four;
  //   const { Ctitle, Cp } = InfoContent.Blog_49.conclusion;

  const { liss2 } = ListContent.Blog_49.L2;


  return (
    <>
      <Helmet>
        <title>Recurrent Miscarriage Causes & When to Get Tested | Acme Fertility</title>

        <meta
          name="description"
          content="Learn about recurrent miscarriage causes, including genetic, uterine, hormonal and autoimmune factors, and understand when testing and fertility evaluation may be recommended."
        />

        <meta name="keywords" content="recurrent miscarriage causes, recurrent pregnancy loss, recurrent miscarriage treatment, miscarriage causes, recurrent pregnancy loss testing, miscarriage testing, fertility evaluation, repeated miscarriage, recurrent miscarriage evaluation, fertility specialist" />

        <link
          rel="canonical"
          href="https://www.acmefertility.com/49/recurrent-miscarriage-causes-testing"
        />

        {/* Article Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "@id": "https://www.acmefertility.com/49/IUI-vs-IVF#article",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id": "https://www.acmefertility.com/49/IUI-vs-IVF",
            },
            headline:
              "How to Improve Egg Quality Naturally: Diet, Supplements & Lifestyle Tips",
            description:
              "A guide covering diet, supplements, sleep, stress, and lifestyle strategies to support egg quality naturally for fertility and IVF success.",
            articleSection: "Fertility",
            keywords:
              "egg quality, fertility diet, CoQ10, vitamin D, IVF, ovulation, natural fertility",
            author: {
              "@type": "Organization",
              name: "Acme Fertility",
            },
            publisher: {
              "@type": "Organization",
              name: "Acme Fertility",
            },
            inLanguage: "en",
          })}
        </script>

        {/* Author Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "@id": "https://www.acmefertility.com/#author",
            name: "Acme Fertility",
            url: "https://www.acmefertility.com/",
          })}
        </script>

        {/* FAQ Schema */}
            <script type="application/ld+json">
            {JSON.stringify({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What are the common causes of recurrent miscarriage?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Recurrent miscarriage can be associated with chromosomal problems, uterine abnormalities, antiphospholipid syndrome, thyroid or metabolic conditions, and certain male fertility factors. Sometimes no clear cause is found."
      }
    },
    {
      "@type": "Question",
      "name": "When should you get tested for recurrent miscarriage?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "After two or more miscarriages, it is reasonable to discuss an evaluation with a gynecologist or fertility specialist. The tests recommended depend on your medical history, age and previous pregnancy history."
      }
    },
    {
      "@type": "Question",
      "name": "Can recurrent miscarriage be treated?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Treatment depends on the underlying cause. Some conditions, such as certain uterine abnormalities, thyroid problems or antiphospholipid syndrome, may have specific treatment options. In some cases, no clear cause is identified."
      }
    },
    {
      "@type": "Question",
      "name": "Does recurrent miscarriage mean I cannot have a successful pregnancy?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Not necessarily. Even when no specific cause is identified, many people with recurrent pregnancy loss can go on to have a successful pregnancy with appropriate medical guidance and care."
      }
    }
  ]
}
)}
            </script>
        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "@id": "https://www.acmefertility.com/49/IUI-vs-IVF#breadcrumb",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.acmefertility.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Fertility",
                item: "https://www.acmefertility.com/Fertility.php",
              },
              {
                "@type": "ListItem",
                position: 3,
                name: "How to Improve Egg Quality Naturally: Diet, Supplements & Lifestyle Tips",
                item: "https://www.acmefertility.com/49/IUI-vs-IVF",
              },
            ],
          })}
        </script>
      </Helmet>

      <AboutInnerBanner image={image} heading={heading} pageName={pageName} />

      <div className="blog-area pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <HeadDesign
                bg={bg}
                para={para}
                date={date}
                blogHeading={blogHeading}
              />

              <Info title={title} p={p} />
              <Info title={title2} p={p2} />
               <List liss={liss2} />
              <Info p={p2a} />
              <Info title={title3} p={p3} />
              <Info title={title4} p={p4} />

            </div>

            <div className="col-lg-4">
              <RecentBlogsList />
              <RightHandSide />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog49;
